import useFetch from '@hooks/useFetch';
import { getIsLoggedIn } from '@api/selectors/auth';
import useMyInfo from '../auth/useMyInfo';

const useEducatorFollowers = () => {
  const isLoggedIn = useMyInfo(getIsLoggedIn);
  const {
    data: followedEducators,
    isLoading,
    mutate: refetchFollowedEducator
  } = useFetch(
    isLoggedIn ? 'sheldon/v1/user/followed-educators' : null,
    undefined,
    {
      revalidateOnMount: true,
      dedupingInterval: 2 * 60 * 60 * 1000
    }
  );

  return { followedEducators, isLoading, refetchFollowedEducator };
};

export default useEducatorFollowers;
